import React from "react";
import { Banknote, ClipboardCheck, CreditCard, PackageCheck, UsersRound, ShieldCheck } from "lucide-react";

import { Hero, FeaturesGrid, CTASection } from "../Components/sections";
import Seo from "../Components/seo/Seo";
import { products } from "../content/products";

function EbERP() {
  const product = products.find((p) => p.id === "erp");

  return (
    <div>
      <Seo title="EasyBooks ERP" description={product.description} />
      <Hero
        eyebrow="Product"
        title="EasyBooks ERP"
        subtitle={product.description}
        primaryCta={{ label: "Request a demo", to: "/Contact" }}
        secondaryCta={{ label: "See Accounting", to: "/EasyBooks_Accounting" }}
        imageSrc={product.heroSrc}
        imageAlt="EasyBooks ERP"
        highlights={product.highlights}
      />

      <FeaturesGrid
        eyebrow="What you get"
        title="Operational control without the manual work."
        subtitle="Digitize core workflows with approvals, analytics, and audit-ready records."
        columns={3}
        features={[
          {
            title: "Budget control",
            description: "Import templates, track spend, and add approval controls for over-spends.",
            icon: Banknote,
          },
          {
            title: "Payments management",
            description: "Integrations for streamlined payments to suppliers, staff, and participants.",
            icon: CreditCard,
          },
          {
            title: "Finance, accounting & audit",
            description: "Transparent tracking with source documents just a click away.",
            icon: ShieldCheck,
          },
          {
            title: "HR & payroll",
            description: "Go paperless with leave, loans, advances, overtime, and employee records.",
            icon: UsersRound,
          },
          {
            title: "Procurement & inventory",
            description: "Digitize RFP/RFQ, POs, invoices, delivery notes, and manage inventory by location.",
            icon: PackageCheck,
          },
          {
            title: "Grant/project management",
            description: "Work plan budgeting and self-service requests with structured approvals.",
            icon: ClipboardCheck,
          },
        ]}
      />

      <CTASection
        title="Let’s map ERP to your workflows."
        subtitle="We’ll review your current processes and recommend the right modules and rollout approach."
        primaryCta={{ label: "Talk to an expert", to: "/Contact" }}
        secondaryCta={{ label: "Explore IMERIS", to: "/EasyBooks_IMERIS" }}
      />
    </div>
  );
}

export default EbERP;